import axios from "axios";

// Determine the base URL based on environment
const getBaseURL = () => {
  // Check if we're in production (using environment variable)
  if (process.env.VUE_APP_API_URL) {
    return process.env.VUE_APP_API_URL;
  }
  
  // Check if running on production domain
  if (window.location.hostname === 'raintree.trudsitsolutions.com') {
    return 'https://raintree.trudsitsolutions.com/api';
  }
  
  // Default to localhost for local development
  return 'http://localhost:5000/api';
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Enable sending cookies with requests
});

console.log('Axios base URL configured as:', getBaseURL());

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify or add any headers, if needed
    console.log("Request Config:", config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error.response || error.message);
  }
);

export default axiosInstance;
